import { IconErrorL } from 'icons/components/IconErrorL'
import { IconInfoL } from 'icons/components/IconInfoL'
import { IconReportL } from 'icons/components/IconReportL'
import { cx } from 'utils/cx'
import type { ClientLinkProps } from 'utils/link/client'
import type { ServerLinkProps } from 'utils/link/server'

import styles from './ContextualMessage.module.scss'
import text from 'fukku/styles/texts.module.scss'

const ICON_SIZE = 24

export enum CONTEXTUAL_MESSAGE_TYPE {
	ERROR = 'error',
	WARNING = 'warning',
	INFO = 'info',
	DEFAULT = 'default',
}

export interface ContextualMessageProps {
	className?: string
	'data-testid'?: string
	message: React.ReactNode
	title?: React.ReactNode
	type?: CONTEXTUAL_MESSAGE_TYPE
	showIcon?: boolean
	link?: React.ReactElement<ClientLinkProps | ServerLinkProps>
}

const ContextualMessageIcons = {
	error: <IconErrorL width={ICON_SIZE} height={ICON_SIZE} />,
	warning: <IconReportL width={ICON_SIZE} height={ICON_SIZE} />,
	info: <IconInfoL width={ICON_SIZE} height={ICON_SIZE} />,
	default: <IconInfoL width={ICON_SIZE} height={ICON_SIZE} />,
}

export function ContextualMessage(
	contextualMessageProps: ContextualMessageProps
) {
	const {
		className,
		'data-testid': dataTestId,
		message,
		showIcon = false,
		title,
		type = CONTEXTUAL_MESSAGE_TYPE.DEFAULT,
		link,
	} = contextualMessageProps

	return (
		<div
			className={cx(styles.contextualMessage, styles[type], className)}
			data-testid={dataTestId ?? `contextualMessage.${type}`}
		>
			<div className={styles.wrapper}>
				{showIcon && (
					<span className={styles.icon}>{ContextualMessageIcons[type]}</span>
				)}
				<div className={styles.content}>
					{title && <span className={text.titleM}>{title}</span>}
					<span className={text.bodyM}>{message}</span>
				</div>
			</div>
			{link && <div className={styles.link}>{link}</div>}
		</div>
	)
}
